import { TaskHubType } from "./TaskHub";

const HubSelector = ({
  value,
  onChange,
  options,
}: {
  value: string;
  onChange: (v: TaskHubType) => void;
  options?: { label: string; value: TaskHubType; img?: string; alt?: string }[];
}) => {
  return (
    <div className="flex gap-3">
      {options?.map((opt) => (
        <button
          type="button"
          key={opt.value}
          onClick={() => onChange(opt.value)}
          className={`w-16 h-16 overflow-hidden rounded-full border-2 flex items-center justify-center transition 
            ${value === opt.value ? "border-gray-800" : "border-transparent"}`}
        >
          <img
            src={opt.img || ""}
            alt={opt.img}
            className="w-12 h-12 object-contain overflow-hidden"
          />
        </button>
      ))}
    </div>
  );
};

export { HubSelector };
